import { Component, OnInit, Inject } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { GtmService } from '../../../../shared/cardholders-core/services/gtm.service';
import { UiHelperService } from '../../../../shared/cardholders-core/services/ui-helper.service';
import { ICampignPopup } from '../../models/campign-popup';

@Component({
    selector: 'app-campaign-popup',
    templateUrl: './campaign-popup.component.html',
    styleUrls: ['./campaign-popup.component.scss']
})
export class CampaignPopupComponent implements OnInit {
    isMobile: boolean;

    constructor(
        private gtmService: GtmService,
        private uiHelper: UiHelperService,
        private _bottomSheetRef: MatBottomSheetRef<CampaignPopupComponent>,
        @Inject(MAT_BOTTOM_SHEET_DATA) public data: ICampignPopup
    ) { }

    closePopUp(event: MouseEvent | KeyboardEvent): void {
        if (event instanceof MouseEvent || (event instanceof KeyboardEvent && (event.key === 'Enter' || event.key === ' '))) {
            this.gtmService.push("splash web", "59", this.data.recomandationId?.toString(), "4");
            this._bottomSheetRef.dismiss();
            event.preventDefault();
        }
    }

    ngOnInit(): void {
        this.isMobile = this.uiHelper.IsMobile();
        if (this.data !== null && this.data.recomandationId)
            this.gtmService.push("splash web", "59", this.data.recomandationId?.toString(), "1");
    }

    buttonClick() {
        this.gtmService.push("splash web", "59", this.data.recomandationId?.toString(), "2");
         window.open(this.data.buttonLink, "_blank");
        this._bottomSheetRef.dismiss();
    }
}